module.exports = __webpack_public_path__ + "img/hub.54c989c2.png";